import { useCallback, useEffect, useState } from 'react';

export default function useAdminReviewList(fetchPage, { search = '', country = '', status = '' } = {}) {
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [cursor, setCursor] = useState({ key: '', page: 1 });
  const [revision, setRevision] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState({ results: [], pagination: { count: 0, pages: 1 }, summary: {}, countries: [] });
  const key = JSON.stringify([debouncedSearch, country, status]);
  const page = cursor.key === key ? cursor.page : 1;
  const setPage = useCallback(value => setCursor({ key, page: typeof value === 'function' ? value(page) : value }), [key, page]);
  const refresh = useCallback(() => setRevision(value => value + 1), []);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedSearch(search.trim()), 300);
    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    let active = true;
    setError('');
    fetchPage({ page, search: debouncedSearch || undefined, country: country || undefined, status: status || undefined })
      .then(response => {
        if (!active) return;
        const payload = response.data;
        const rows = payload.results || (Array.isArray(payload) ? payload : []);
        const pagination = payload.pagination || { page: 1, pages: 1, count: rows.length };
        setData({ results: rows, pagination, summary: payload.summary || { total: pagination.count }, countries: payload.countries || [] });
        if (pagination.page && pagination.page !== page) setCursor({ key, page: pagination.page });
      })
      .catch(() => { if (active) setError('Error al cargar datos'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [fetchPage, key, page, debouncedSearch, country, status, revision]);

  return { ...data, loading, error, page, setPage, refresh };
}
